import { RouteObject } from 'react-router-dom';
import { PublicDashboardPage } from './pages/public-dasboard.page';
import { DashboardRoutes } from './constants';

export const DashboardModuleRouter: RouteObject[] = [
	{
		path: DashboardRoutes.Root,
		element: <PublicDashboardPage />,
		handle: {
			title: 'nav.dashboard',
			needsDrawer: false,
			fullWidth: true,
		},
	},
];
